export const logError = message => {
    console.error(message);
};
